import * as React from 'react'
import PhotoUploadIcon from '../icons/ui/PhotoUploadIcon'
//Generate Avatar
import Avatar, { ConfigProvider } from 'react-avatar'

interface IProps {
  entityId?: string
  onUpload?: (hashId: string) => void
  isOption?: boolean
  isLocked?: boolean
  name?: string
}

interface IState {
  data?: any
  file: any
  onError: boolean
  highlight: boolean
}

class ImageUploadDriver extends React.Component<IProps, IState> {
  private inputDivRef: any = null

  constructor(props: IProps) {
    super(props)
    this.state = {
      data: null,
      file: null,
      onError: false,
      highlight: false
    }
    this.inputDivRef = React.createRef()
  }

  public getBucketName = () => {
    return process.env.REACT_APP_ENV === 'production'
      ? process.env.REACT_APP_S3_BUCKET_PROD
      : process.env.REACT_APP_S3_BUCKET_DEV
  }

  public submit = async (): Promise<any> => {
    const id = this.props.entityId
    if (!id) {
      return
    }

    const AWS = require('aws-sdk')
    const sha1 = require('sha1')
    const key: string = sha1(id)
    AWS.config.update({
      region: 'us-east-1',
      credentials: new AWS.CognitoIdentityCredentials({
        IdentityPoolId: 'us-east-1:f165c051-74b8-472a-98d4-0eb8b47f996a'
      })
    })
    return new Promise(approve => {
      if (!this.state.file) {
        approve()
        return
      }
      const s3 = new AWS.S3({ useAccelerateEndpoint: false })
      const params = { Bucket: `${this.getBucketName()}/uploads`, Key: key + '.png', Body: this.state.file }
      s3.upload(params, (err: any, data: any) => {
        if (this.props.onUpload) {
          this.props.onUpload(key)
        }
        approve(key)
      })
    })
  }

  public render() {
    // const sha1 = require('sha1')
    // const filename = sha1(this.props.entityId)
    return (
      <div>
        <input
          onChange={this.onSelectImage}
          ref={this.inputDivRef}
          accept='image/*'
          type='file'
          name='name'
          style={{ display: 'none' }}
        />
        <div
          onClick={this.onClick}
          onDragOver={this.onDragOver}
          onDragLeave={this.onDragLeave}
          onDrop={this.onDrop}
          className={
            this.state.highlight
              ? 'ImageUpload flex flex-row items-center cursor--pointer b-rad-5 border-style-dashed border-light-grey bg-light-grey9 px1 py1'
              : 'ImageUpload flex flex-row items-center cursor--pointer b-rad-5 border-style-dashed border-light-grey px1 py1'
          }
        >
          {!this.state.data && !this.props.entityId && (
            <PhotoUploadIcon className='PhotoUploadIcon pl2 pt1 pb1 pr3 icon--96x96' />
          )}
          {this.state.data && (
            <img style={{ maxWidth: '96px', maxHeight: '96px', display: 'block' }} src={this.state.data} />
          )}

          {/* With Uploaded Image and Without image (based on Function) */}
          {!this.state.data && this.props.entityId && (
            // <ConfigProvider colors={['#00c2fb', '#812f75', '#7e0040', '#151ea5', '#22040a', '#ff8029']}>
            // <ConfigProvider colors={['#00c2fb', '#812f75', '#ff8029', '#58d454', '#ff8029', '#ee3615']}>
            <ConfigProvider colors={['#d05030', '#7ed8ec', '#127c94', '#f9d70b', '#83e7b2', '#5b65ab']}>
              <Avatar
                className='bold-avatar'
                name={this.props.name}
                size='60px'
                textMarginRatio={0.15}
                round={true}
                textSizeRatio={10}
                color='rgb(202, 241, 222)'
                src={this.getURL()}
              />
            </ConfigProvider>
            /* <img
              onError={this.onError}
              style={{ maxWidth: '96px', maxHeight: '96px', display: 'block' }}
              src={this.getURL()}
            /> */
          )}
          {/* With Uploaded Image and Without image (based on Function) */}

          <div className='pl1'>
            <div className='font-green h6'>Click to browse</div>
            {/* TODO: add drag & drop */}
            <div className='font-light-grey h6'>or Drag and Drop image here</div>
          </div>
        </div>
      </div>
    )
  }

  private onError = () => {
    this.setState({
      onError: true
    })
  }

  private getURL = () => {
    const sha1 = require('sha1')
    const filename = sha1(this.props.entityId)
    const uniqueIdentifier = new Date().getTime()
    console.log('Inside getURL: ', {
      props: this.props,
      filename,
      url: `https://${this.getBucketName()}.s3.amazonaws.com/uploads/${filename}.png`
    })
    return this.state.onError
      ? /* Default Image '/images/goin-placeholder-logo.png' */
        /* New Default Image */
        ``
      : /* New Default Image */
        `https://${this.getBucketName()}.s3.amazonaws.com/uploads/${sha1(
          this.props.entityId
        )}.png?t=${uniqueIdentifier}`
  }

  private onClick = () => {
    this.inputDivRef.current.click()
  }

  private onDragOver = (event: any) => {
    event.preventDefault()
    this.setState({ highlight: true })
  }

  private onDragLeave = () => this.setState({ highlight: false })

  private onDrop = (event: any) => {
    event.preventDefault()
    if (event.dataTransfer.files.length < 1) {
      return
    }
    const file = event.dataTransfer.files[0]
    this.readFile(file)
    this.setState({ highlight: false })
  }

  private onSelectImage = (event: any) => {
    if (event.target.files.length < 1) {
      return
    }
    const file = event.target.files[0]
    this.readFile(file)
  }

  private readFile = (file: any) => {
    const me = this
    const reader = new FileReader()
    reader.onload = (e: any) => {
      me.setState(
        {
          onError: false,
          data: e.target.result,
          file
        },
        () => {
          me.submit()
        }
      )
    }
    reader.readAsDataURL(file)
  }
}

export default ImageUploadDriver



// WEBPACK FOOTER //
// ./src/components/ui/ImageUploadDriver.tsx